import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["size", "className", "children", "tag", "onClick", "onKeyDown", "role", "id", "iconStart", "iconEnd", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '../../useDesignTokens';
import * as views from './ButtonText.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseButtonText = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      className = _ref.className,
      children = _ref.children,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "button" : _ref$tag,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      role = _ref.role,
      id = _ref.id,
      IconStart = _ref.iconStart,
      IconEnd = _ref.iconEnd,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsxs(views.ButtonText, _objectSpread(_objectSpread(_objectSpread({
    tag: rest.href ? "a" : tag,
    ref: ref,
    className: className,
    onClick: onClick,
    onKeyDown: onKeyDown,
    role: role,
    id: id
  }, tokens), rest), {}, {
    variant: size === "medium" ? "buttonTextMedium" : "buttonTextSmall",
    children: [IconStart ? _jsx(IconStart, {
      size: size
    }) : null, children, IconEnd ? _jsx(IconEnd, {
      size: size
    }) : null]
  }));
});
export var ButtonText = withDesignTokens(BaseButtonText, function (_ref2) {
  var color = _ref2.color,
      size = _ref2.size,
      hover = _ref2.hover,
      iconStart = _ref2.iconStart,
      iconEnd = _ref2.iconEnd;
  return {
    color: color,
    width: iconStart || iconEnd ? "calc(100% - ".concat(size === "small" ? 5 : 7, "px)") : "100%",
    iconStart: Boolean(iconStart),
    hover: hover
  };
}, {
  light: function light(theme, _ref3) {
    var variant = _ref3.variant,
        color = _ref3.color;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "mono":
        return {
          textColor: theme.palette.neutrals.black[100],
          hoverColor: theme.palette.neutrals.black[100]
        };

      case "brand":
      default:
        return {
          textColor: theme.palette.brand.boysenberry[500],
          hoverColor: theme.palette.brand.boysenberry[500]
        };
    }
  },
  dark: function dark(theme, _ref4) {
    var color = _ref4.color,
        variant = _ref4.variant;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "mono":
        return {
          textColor: theme.palette.neutrals.white[100],
          hoverColor: theme.palette.neutrals.white[100]
        };

      case "brand":
      default:
        return {
          textColor: theme.palette.brand.segmentGreen[500],
          hoverColor: theme.palette.brand.segmentGreen[500]
        };
    }
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var color = _ref5.color,
        _ref5$variant = _ref5.variant,
        variant = _ref5$variant === void 0 ? "primary" : _ref5$variant;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "secondary":
        return {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        };

      case "mono":
        return {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        };

      case "primary":
      default:
        return {
          textColor: theme.palette.twilio.blue[60],
          hoverColor: theme.palette.twilio.blue[70]
        };
    }
  },
  twilioDark: function twilioDark(theme, _ref6) {
    var color = _ref6.color,
        _ref6$variant = _ref6.variant,
        variant = _ref6$variant === void 0 ? "primary" : _ref6$variant;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "secondary":
        return {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        };

      case "mono":
        return {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        };

      case "primary":
      default:
        return {
          textColor: theme.palette.neutrals.white[100],
          hoverColor: theme.palette.neutrals.white[100]
        };
    }
  },
  cdpWeek2023: function cdpWeek2023(theme, _ref7) {
    var color = _ref7.color,
        _ref7$variant = _ref7.variant,
        variant = _ref7$variant === void 0 ? "primary" : _ref7$variant;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "secondary":
        return {
          textColor: theme.palette.cdpWeek2023.blue[40],
          hoverColor: theme.palette.cdpWeek2023.blue[40]
        };

      case "mono":
        return {
          textColor: theme.palette.neutrals.white[100],
          hoverColor: theme.palette.neutrals.white[100]
        };

      case "primary":
      default:
        return {
          textColor: theme.palette.cdpWeek2023.blue[40],
          hoverColor: theme.palette.cdpWeek2023.blue[40]
        };
    }
  }
});
export default ButtonText;